<script>
import { BButton } from 'bootstrap-vue';
import Cleave from 'vue-cleave-component';

export default {
  components: {
    Cleave,
    BButton,
  },

  props: {
    name: {
      type: String,
      required: true,
    },

    currentForm: {
      type: Object,
      required: false,
      default: null,
    },

    editing: {
      type: Boolean,
      required: true,
    },
  },

  mounted () {
    this.form.name = this.name || '';

    if (this.currentForm) {
      this.form = { ...this.form, ...this.currentForm };
    }
  },

  data: () => ({
    errors: {
      //
    },

    form: {
      name: '',
      price: 0,
      inline: false,
      installments: 1,
      one_click: true,
      action: 'message',
      action_content: '',
      button: 'Finalizar Compra',
      installment_fee_type: null,
      methods: {
        pix: false,
        creditcard: true,
        bankslip: false,
      },
    },

    config: {
      prefix: 'R$',
      numeral: true,
      delimiter: '.',
      numeralDecimalScale: 2,
      numeralDecimalMark: ',',
      rawValueTrimPrefix: true,
    },
  }),

  computed: {
    actions () {
      return [
        {
          text: this.__('Redirecionar para uma página'),
          value: 'redirect',
        },
        {
          text: this.__('Exibir um texto / HTML'),
          value: 'message',
        },
      ];
    },

    actionLabel () {
      const {
        action,
      } = this.form;

      return action === 'redirect' ? this.__('Link para o redirecionamento') : this.__('Texto/HTML da ação');
    },

    max () {
      const {
        price,
      } = this.form;

      return Math.min(Math.max(Math.round(price / 5), 1), 12);
    },

    methods () {
      return [
        {
          label: 'Pagamento à vista',
          value: null,
        },
        {
          label: 'Parcelado COM tarifas para seu cliente (seu cliente é quem paga as tarifas)',
          value: 'customer',
        },
        {
          label: 'Parcelado SEM tarifas para seu cliente (o responsável pelas tarifas é você, Produtor)',
          value: 'tenant',
        },
      ];
    },
  },

  methods: {
    close () {
      if (this.currentForm) {
        this.$http.put(`/form/checkout/${this.form.hashid}`, this.form)
          .then(({ data }) => {
            this.$emit('back', { ...data.form, tenant: data.tenant });
          })
          .catch(({ body, status, bodyText = '' }) => {
            if (status === 422 && bodyText.includes('tenant')) {
              Bus.$emit('openModalEditAccount', 'Atualize os dados da sua conta');

              return;
            }

            this.errors = body;
          });

        return;
      }

      this.$http.post('/form/checkout', this.form)
        .then(({ data }) => {
          this.$emit('back', { ...data.form, tenant: data.tenant });
        })
        .catch(({ body, status, bodyText = '' }) => {
          if (status === 422 && bodyText.includes('tenant')) {
            Bus.$emit('openModalEditAccount', 'Atualize os dados da sua conta');

            return;
          }

          this.errors = body;
        });
    },
  },

  watch: {
    'form.price': function () {
      this.form.installments = 1;
    },
  },
};
</script>

<template>
  <div
    class="form-builder-checkout bdk-max-h-3/4"
  >
    <div
      class="form-builder-checkout__wrapper"
    >
      <label
        class="form-builder-dialog__label"
      >
        {{ __('Nome do Produto') }}

        <input
          v-model="form.name"
          placeholder="Digite aqui"
          class="form-builder-dialog__input"
        >

        <span
          v-if="errors.name"
          v-text="errors.name[0]"
          class="form-builder-dialog__input-error"
        />
      </label>

      <label
        class="form-builder-dialog__label"
      >
        {{ __('Preço do Produto') }}

        <Cleave
          :options="config"
          v-model="form.price"
          placeholder="Digite aqui"
          class="form-builder-dialog__input"
        />

        <span
          v-if="errors.price"
          v-text="errors.price[0]"
          class="form-builder-dialog__input-error"
        />
      </label>

      <div
        class="form-builder-checkout__checkbox form-builder-dialog__label"
      >
        {{ __('Métodos de Pagamento') }}

        <label
          class="form-builder-dialog__label form-builder-dialog__label--checkbox"
        >
          <input
            type="checkbox"
            v-model="form.methods.creditcard"
            class="form-builder-checkout__checkbox-input"
          >

          <span
            class="form-builder-checkout__checkbox-label"
          >
            {{ __('Cartão de Crédito') }}
          </span>
        </label>

        <label
          class="form-builder-dialog__label form-builder-dialog__label--checkbox"
        >
          <input
            type="checkbox"
            v-model="form.methods.bankslip"
            class="form-builder-checkout__checkbox-input"
          >

          <span
            class="form-builder-checkout__checkbox-label"
          >
            {{ __('Boleto Bancário e Pix') }}
          </span>
        </label>

        <span
          v-if="errors.payment_available"
          class="form-builder-dialog__input-error"
        >
          {{ __('Defina no mínimo 1 (um) método de pagamento.') }}
        </span>
      </div>

      <label
        class="form-builder-dialog__label"
      >
        {{ __('Formas de pagamento') }}

        <select
          name="type"
          required="required"
          autofocus="autofocus"
          v-model="form.installment_fee_type"
          class="form-builder-dialog__input form-control"
        >
          <option
            :key="value"
            v-text="label"
            :value="value"
            v-for="({ label, value }) in methods"
          />
        </select>
      </label>

      <label
        v-if="form.methods.creditcard && form.installment_fee_type !== null"
        class="form-builder-dialog__label"
      >
        {{ __('Número Máximo de Parcelas*') }}

        <select
          name="type"
          required="required"
          autofocus="autofocus"
          v-model="form.installments"
          class="form-builder-dialog__input form-control"
        >
          <option
            :key="n"
            :value="n"
            v-text="n"
            v-for="n in max"
          />
        </select>

        <span
          v-if="errors.installments"
          v-text="errors.installments[0]"
          class="form-builder-dialog__input-error"
        />

        <span
          v-else
          class="form-builder-dialog__input-warning"
        >
          {{ __('O valor mínimo de cada parcela precisa ser de R$5,00') }}
        </span>
      </label>

      <label
        class="form-builder-dialog__label"
      >
        {{ __('Texto do botão do formulário') }}

        <input
          v-model="form.button"
          placeholder="Digite aqui"
          class="form-builder-dialog__input"
        >
      </label>

      <label
        class="form-builder-dialog__label"
      >
        {{ __('Ação após o envio') }}

        <select
          name="type"
          required="required"
          autofocus="autofocus"
          v-model="form.action"
          class="form-builder-dialog__input form-control"
        >
          <option
            :key="action.value"
            v-text="action.text"
            :value="action.value"
            v-for="action in actions"
          />
        </select>
      </label>

      <label
        class="form-builder-dialog__label"
      >
        {{ actionLabel }}

        <input
          type="url"
          name="rules"
          v-model="form.action_content"
          v-if="form.action === 'redirect'"
          class="form-builder-dialog__input form-control"
        >

        <textarea
          v-else
          rows="5"
          name="rules"
          v-model="form.action_content"
          class="form-builder-dialog__input form-control"
        />
      </label>

      <div
        class="form-builder-checkout__checkbox form-builder-dialog__label"
      >
        {{ __('Formato do Formulário') }}

        <label
          class="form-builder-dialog__label form-builder-dialog__label--checkbox bdk-mt-1"
        >
          <input
            type="checkbox"
            v-model="form.inline"
            class="form-builder-checkout__checkbox-input"
          >

          <span
            class="form-builder-checkout__checkbox-label"
          >
            {{ __('Checkout Embedado na Página') }}
          </span>
        </label>

        <label
          class="form-builder-dialog__label form-builder-dialog__label--checkbox bdk-mt-1"
        >
          <input
            type="checkbox"
            v-model="form.one_click"
            class="form-builder-checkout__checkbox-input"
          >

          <span
            class="form-builder-checkout__checkbox-label"
          >
            {{ __('Habilitar One Click Sell') }}
          </span>
        </label>
      </div>
    </div>

    <div
      class="form-builder-dialog__footer bdk-bg-white"
    >
      <BButton
        type="submit"
        v-if="! editing"
        variant="secundary"
        @click.prevent="$emit('closeEdit')"
        class="form-builder-dialog__button"
      >
        <span>
          {{ __('Voltar') }}
        </span>
      </BButton>

      <BButton
        type="submit"
        variant="primary"
        @click.prevent="close()"
        class="form-builder-dialog__button"
      >
        <span
          v-if="editing"
        >
          {{ __('Editar Formulário de Checkout') }}
        </span>

        <span
          v-else
        >
          {{ __('Criar Formulário de Checkout') }}
        </span>
      </BButton>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .form-builder-checkout {
    width: 100%;
    display: flex;
    align-items: center;
    flex-flow: column nowrap;

    &__wrapper {
      width: 100%;
      overflow: auto;
      padding: 0px 8px;
    }

    &__checkbox {
      &-input {
        margin-right: 4px;
      }
    }
  }
</style>
